import { has } from "../../../../../utils/menu-context";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (has({ menuContext, key: "canEdit" })) {
                result = true || result;
            }
            return result;
        }
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return [
                    "refDepartment",
                    "cancelSequestrateDate",
                    "regulation",
                    "customer",
                    "openInspector",
                    "resultRemark",
                    "refResult",
                    "cause",
                    "activity",
                    "refSequestrate",
                    "approveCode",
                    "refCancelSequestrate",
                ].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                const regExps = [
                    new RegExp(`^products\\.[^\\.]+\\.(regNo|samplingNo|analysisResult|remark)$`, "g"),
                    new RegExp(`^addresses\\.[^\\.]+\\.(noTh|roomTh|buildingTh|floorTh|villageTh|mooTh|soiTh|roadTh|refProvince|refAmphur|refTambon|postCode|tel|fax)$`, "g"),
                    new RegExp(`^attachments\\.[^\\.]+\\.(documentName|(attribute\\.(documentNo|documentDate|documentExpiredDate))|size)$`, "g"),
                    new RegExp(`^refSequestrate.addresses\\.[^\\.]+\\.(refAddressType|latitude|longitude|map)`, "g"),
                ];
                return regExps.some(d => d.test(field?.key));
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                const regExps = [
                    new RegExp(`^addresses\\.[^\\.]+\\.(refAddressType|latitude|longitude|map)`, "g"),
                    new RegExp(`^refSequestrate.addresses\\.[^\\.]+\\.(refAddressType|latitude|longitude|map)`, "g"),
                ];
                return regExps.some(d => d.test(field?.key));
            },
            visibleField: () => {
                return false
            },
        },
    ];
};

